import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { scroll } from "../App"; // your SmoothScroll instance

const SECTIONS = [
  { id: "about", label: "Über uns" },
  { id: "services", label: "Leistungen" },
  { id: "portfolio", label: "Galerie" },
  { id: "testimonials", label: "Referenzen" },
  { id: "team", label: "Team" },
  { id: "contact", label: "Kontakt" },
];

export const Navigation = () => {
  const navigate = useNavigate();

  // Close mobile menu (tries to use Bootstrap behavior by clicking the toggle,
  // falls back to removing the collapse classes).
  const closeMobileMenu = () => {
    // Try to find the toggle button for both Bootstrap 3 (.navbar-toggle) and 4/5 (.navbar-toggler)
    const toggle = document.querySelector(".navbar-toggle, .navbar-toggler");
    // If toggle is not visible (desktop), do nothing
    if (!toggle) return;
    const isVisible = window.getComputedStyle(toggle).display !== "none";
    if (!isVisible) return;

    // Prefer clicking the toggle so native Bootstrap JS handles aria/classes
    try {
      toggle.click();
      return;
    } catch (err) {
      // if click fails, continue to fallback
    }

    // Fallback: manually collapse element(s)
    const collapse =
      document.getElementById("bs-example-navbar-collapse-1") ||
      document.querySelector(".navbar-collapse");
    if (collapse) {
      // Remove common "open" classes for different Bootstrap versions
      collapse.classList.remove("in"); // bs3
      collapse.classList.remove("show"); // bs4/bs5
      // update aria-expanded attributes
      collapse.setAttribute("aria-expanded", "false");
      if (toggle) toggle.classList.add("collapsed");
    }
  };

  const scrollToSection = (id) => {
    const el = document.getElementById(id);

    if (!el) {
      // Not on homepage → navigate first
      if (window.location.pathname !== "/") {
        navigate("/");
        // Wait for homepage to render, then scroll and close menu
        setTimeout(() => {
          const targetEl = document.getElementById(id);
          if (targetEl) {
            scroll.animateScroll(targetEl);
          }
          // Close the mobile menu after scrolling/navigation
          closeMobileMenu();
        }, 200); // you can increase if your homepage takes longer to render
      }
      return;
    }

    // Already on homepage → scroll smoothly then close menu
    scroll.animateScroll(el);
    // close menu a tiny bit after scrolling starts so user sees transition
    setTimeout(closeMobileMenu, 50);
  };

  return (
    <nav
      id="menu"
      className="navbar navbar-default navbar-fixed-top"
      aria-label="Hauptnavigation"
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-controls="bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            <span className="sr-only">Navigation ein-/ausblenden</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          {/* Der Bildpfad muss absolut sein: die Navigation steht auf jeder
              Route. Relativ ("img/…") löst der Browser ihn gegen den aktuellen
              Pfad auf – unter /impressum/ wird daraus /impressum/img/… und das
              Logo bricht. Dasselbe gilt für die 404-Seite, die Netlify unter
              beliebig tiefen Pfaden ausliefert. */}
          <Link className="navbar-brand logo-img" to="/">
            <img
              src="/img/Merdovic Logo-Bild- und Textmarke.png"
              alt="Merdovic Trockenbau"
              className="logo-img"
            />
          </Link>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {SECTIONS.map(({ id, label }) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  className="page-scroll"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(id);
                  }}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
